import { render, staticRenderFns } from "./DikidiLanding.vue?vue&type=template&id=9d364d56&scoped=true"
import script from "./DikidiLanding.vue?vue&type=script&lang=js"
export * from "./DikidiLanding.vue?vue&type=script&lang=js"
import style0 from "./DikidiLanding.vue?vue&type=style&index=0&id=9d364d56&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d364d56",
  null
  
)

export default component.exports